import { render, staticRenderFns } from "./overview-card.vue?vue&type=template&id=2e8b1d0b&scoped=true"
import script from "./overview-card.vue?vue&type=script&lang=js"
export * from "./overview-card.vue?vue&type=script&lang=js"
import style0 from "./overview-card.vue?vue&type=style&index=0&id=2e8b1d0b&prod&lang=scss&scoped=true"
import style1 from "./overview-card.vue?vue&type=style&index=1&id=2e8b1d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b1d0b",
  null
  
)

export default component.exports